import { render } from "./UiSpacer.vue?vue&type=template&id=53fcceb6"
import script from "./UiSpacer.vue?vue&type=script&lang=js"
export * from "./UiSpacer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__